import React, { useState, useEffect } from "react";
import lokiImage from "../Assets/IMG/loki.png"; 
import section1Bg from "../Assets/IMG/BG_03.gif";
const MarketingHeroSection = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const outerWrapper = {
    backgroundImage: `url(${section1Bg})`, 
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingTop: "20px",
  };

  const topSection = {
    textAlign: "center",
    padding: isMobile ? "20px 15px" : "40px 30px",
    fontFamily: "'Gotham', sans-serif",
    color: "#191e35",
  };

  const topTitle = {
    fontSize: isMobile ? "24px" : "38px",
    fontWeight: "bold",
    marginBottom: "10px",
    color:"#191e34"
  };

  const topSubtext = {
    fontSize: isMobile ? "16px" : "20px",
    color: "#2b2e42",
    maxWidth: "800px",
    margin: "0 auto",
    lineHeight: "1.5",
    fontWeight:"500"
  };

  const container = {
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: "center",
    padding: isMobile ? "30px 20px" : "60px 40px",
    gap: isMobile ? "10px" : "7px",
    fontFamily: "'Gotham', sans-serif",
    flexWrap: "wrap",
  };

  const imageWrapper = {
    flex: "1 1 450px",
    display: "flex",
    justifyContent: "center",
    order: isMobile ? 1 : 0,
  };

  const imageStyle = {
    width: "100%",
    maxWidth: "400px",
    borderRadius: "20px",
    
  };

  const textWrapper = {
    flex: "1 1 500px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: isMobile ? "center" : "left",
    marginRight:"10%"
  };

  const title = {
    fontSize: isMobile ? "27px" : "35px",
    fontWeight: "bold",
    marginBottom: "10px",
    color: "#191e34",
  };

  const subtitle = {
    fontSize: isMobile ? "21px" : "27px",
    fontWeight: "600",
    color: "#191e34",
    marginBottom: "20px",
    lineHeight:"1.4"
  };

  const paragraph = {
    fontSize: isMobile ? "17px" : "20px",
    lineHeight: "1.8",
    marginBottom: "20px",
    color: "#2b2e42",
    fontWeight:"500"
  };

  const bottomTextStyle = {
    width: "100%",
    fontSize: isMobile ? "18px" : "22px",
    color: "#191e34",
    padding: isMobile ? "16px 10px" : "20px",
    marginTop: "30px",
    textAlign: "center",
    fontWeight: "600",
  };

  return (
    <section style={outerWrapper}>
      {/* Top Header Text */}
      <div style={topSection}>
        <h1 style={topTitle}>"OUR LAIR YOUR LAUNCHPAD."</h1>
        <p style={topSubtext}>
          This isn’t just an office it’s where reels get real, pixels get pol-<br/>ished, and campaigns are born with superhero precision.
        </p>
      </div>

      {/* Main Content Section */}
      <div style={container}>
        {/* Left - Image */}
        <div style={imageWrapper}>
          <img src={lokiImage} alt="Loki Glorious Purpose" style={imageStyle} />
        </div>

        {/* Right - Text */}
        <div style={textWrapper}>
          <h1 style={title}>WHY CHOOSE US?</h1>
          <h2 style={subtitle}>
            “We’re Not Just Another Agency. We’re a<br/> Little More Glorious.”Loki, Probably.
          </h2>
          <p style={paragraph}>
            At Glowingrowth Media, we don’t follow trends we charm algorithms. From meta ads management to corporate branding,
            graphic designing, and scroll-stopping YouTube shoots, our playbook is sharp, strategic, and made for impact.
            Because your brand deserves brains and boldness.
          </p>
        </div>

        {/* Bottom Tagline */}
        <div style={bottomTextStyle}>
          Not your regular agency. We’re the Avengers of branding with Groot-level charm and Stark-level execution.
        </div>
      </div>
    </section>
  );
};

export default MarketingHeroSection;
